import React from "react";
import { ToastContainer } from "react-toastify";
import ViewTagCollection from "../../components/ProductManager/TagCollection/ViewTagCollection";

export const ViewTagCollectionPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewTagCollection />
        </div>
      </div>
    </div>
  );
};
